<template>
    <div>
        <Card>
            <p slot="title">
                Pending
            </p>

            <Button
                type="success"
                slot="extra"
                size="small"
                @click="modalImport = true">Upload Data</Button>

            <div v-for="paymentPending in paymentPendings" :key="paymentPending.id">
                <PaymentPendingRow :paymentPending="paymentPending" @reloadParent="reload"/>
            </div>
        </Card>

        <Modal
            v-model="modalImport"
            title="Upload Data"
            ok-text="">
                <UploadXls
                    @on-success-upload="onSuccessUpload"
                    @on-error-upload="onErrorUpload"
                    />
                <div slot="footer"></div>
        </Modal>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import UploadXls from '@/components/payment/UploadXls'
import PaymentPendingRow from '@/components/payment/PaymentPendingRow'

// import PaymentHistoryPayNoDetail from '@/components/payment/PaymentHistoryPayNoDetail'

const numeral = require('numeral');

export default {
    components : { UploadXls, PaymentPendingRow},

    data: () => ({
        markingIdSelected : '',
        paymentPendings : [],
        loadingSearch : false,
        modalImport: false

    }),

    methods: {
        getPaymentPendingByFilter: function(){
            this.paymentPendings = []
            let urlFindByFilter = 'paymentPending/findByFilter';

            this.loadingSearch = true;

            HTTP
            .post(urlFindByFilter)
            .then(response => {
                let parent = this;
                console.log(response)

                _.forEach(response.data, function(value) {
                    let markingheadercode = ""
                    if(value.payment){
                        markingheadercode = value.payment.marking_header.markingheadercode
                    }
                    let paymentPending = {
                        id : value.id,
                        amount : value.amount,
                        markingheadercode : markingheadercode,
                        createdby : value.createdby,
                        created_at : value.created_at,
                        transactionDate : value.transactionDate,
                        payment : value.payment,
                        bank_account: value.bank_account
                    }
                    parent.paymentPendings.push(paymentPending);
                });
                this.loadingSearch = false;
            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        onSuccessUpload: function(response){
            this.modalImport = false;
            this.getPaymentPendingByFilter();
            this.$Notice.success({
                title: 'Data berhasil di-upload ',
                desc: ''
            });
        },
        onErrorUpload: function(response){
            this.modalImport;
            this.$Notice.error({
                title: 'Gagal Upload',
                desc: response
            });
        },
        reload: function() {
            this.getPaymentPendingByFilter();
        }



    },
    mounted() {
        this.getPaymentPendingByFilter();
    },
    created() {
    }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// PaymentPendingList.vue?6f64d620